import { Container } from '../../../odie';

import { KettleBlockProps } from '../../defs/block';
import { blockPositionView } from '../../util/blockTools';
import { FitWidthBlockSprite } from './FitWidthBlockSprite';

// constants
//-----------------------------------------------------------------------------
const manifest = {
  image: 'kettle/block.kettle.png',
};

/*
    kettle block view
*/
export class KettleBlockView extends Container {
  // init
  //-------------------------------------------------------------------------
  constructor(props: KettleBlockProps) {
    // spawn
    super();
    this.addChild(new FitWidthBlockSprite(manifest.image, props));

    // position
    blockPositionView(this, props);
  }

  public static assets(): string[] {
    return [manifest.image];
  }
}
